import { CreateMarketplaceLoanResponse } from "@lib/clients/nelo-api-client"

import NeloBackgroundContainer from "./nelo-background-container"

interface LoanNotesContainerProps {
  loanDetails: CreateMarketplaceLoanResponse | null
}

const LoanNotesContainer: React.FC<LoanNotesContainerProps> = ({ loanDetails }) => {
  return (
    loanDetails?.loanInfo.notes && (
      <NeloBackgroundContainer>
        <div>
          <p className="mb-4 font-nunito text-sm text-ui-fg-base">{loanDetails.loanInfo.notes[0]}</p>
          <p className="mb-4 font-nunito text-sm text-ui-fg-base">{loanDetails.loanInfo.notes[2]}</p>
          <p className="font-nunito text-sm text-ui-fg-base">
            A partir de la entrega, cuentas con 30 días para devolver mercancía nueva, sin abrir y en su estado original (aplican
            excepciones y restricciones). Para saber más, consulta nuestra{" "}
            <span>
              <a href="https://www.nelo.mx/es/legal/return_policy" target="_blank" className="text-nelo-blue">
                Política de devoluciones.
              </a>
            </span>
          </p>
        </div>
      </NeloBackgroundContainer>
    )
  )
}

export default LoanNotesContainer
